import { Col, Form } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { IncreasingNumber } from '../IncreasingNumber/IncreasingNumber'

export const BuybackFormSummaryFragmentRentTotal: FunctionComponent = memo(
  () => {
    const rentTotalPrice = Form.useWatch(FIELD.RentTotalPrice) ?? 0

    return (
      <Col xs={24} md={12} xl={8} className="text-center">
        <div className="mb-2">Výše nájmu (včetně služeb a energií)</div>
        <IncreasingNumber
          className="text-2xl"
          finalNumber={rentTotalPrice}
          decimal={0}
          suffix=" Kč/měs."
        />
      </Col>
    )
  }
)
